var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoInteleca(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 3000 1728.7",
    style: {
      enableBackground: "new 0 0 3000 1728.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#ACDECB;}\n\t.st1{fill:#F5CA4E;}\n\t.st2{fill:#022873;}\n\t.st3{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M907.5,1373.4v-179.6h38.2v116.1l83.2-116.1h39.3v179.6H1030V1253l-85.6,120.4H907.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1245.2,1373.4V1298h-84.8v75.4h-38.2v-179.6h38.2v70.6h84.8v-70.6h38.5v179.6H1245.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1378.8,1373.4v-146h-52.5v-33.7h143.3v33.7h-52.2v146H1378.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1512.3,1373.4v-179.6h127.1v33.7h-88.9v38h87v33.7h-87v40.7h88.9v33.7H1512.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1676.9,1342.7c18,0,28.5-9.7,34.2-57.1l10.5-91.8h127.6v179.6h-38.5v-146h-54.7l-7,60.9 c-8.6,74.6-35.5,88.3-72.2,88.3V1342.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1892.1,1342.7c18,0,28.5-9.7,34.2-57.1l10.5-91.8h127.6v179.6h-38.5v-146h-54.7l-7,60.9 c-8.6,74.6-35.5,88.3-72.2,88.3V1342.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M2118,1373.4v-179.6h127.1v33.7h-88.9v38h87v33.7h-87v40.7h88.9v33.7H2118z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M2399.9,1373.4l-54.4-71.9l-14,16.7v55.2h-38.2v-179.6h38.2v80.3l63.6-80.3h47.1l-71.4,84.3l76.2,95.3H2399.9 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M2606.8,1373.4l-11-30.4h-77l-11.3,30.4h-43.6l69.5-179.6h47.9l69.2,179.6H2606.8z M2557.2,1232l-28,77.3h56 L2557.2,1232z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M349.6,882.2c29.6-73.1,73.1-138.6,129.3-194.8c56.2-56.2,121.7-99.7,194.8-129.3 c70.6-28.6,145.1-43.1,221.5-43.1c76.4,0,151,14.5,221.5,43.1l-35.9,88.4c-59.1-24-121.6-36.1-185.7-36.1 c-64.1,0-126.5,12.2-185.7,36.1c-61.2,24.8-116.1,61.3-163.2,108.4c-47.1,47.1-83.6,102-108.4,163.2L349.6,882.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M689.9,898.4l-67.5-67.5c36.8-36.8,79.8-65.3,127.7-84.8c46.2-18.7,95.1-28.3,145.2-28.3 c50.1,0,98.9,9.5,145.2,28.3l-35.9,88.4c-34.8-14.1-71.6-21.3-109.3-21.3c-37.7,0-74.5,7.2-109.3,21.3 C750,849.2,717.6,870.6,689.9,898.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M622.4,1376.6c-36.8-36.8-65.3-79.8-84.8-127.7l88.4-35.9c14.6,36,36.1,68.3,63.8,96.1L622.4,1376.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M833.4,1041.9l-67.5-67.5c17.5-17.5,37.8-31,60.5-40.2c22-8.9,45.1-13.4,68.8-13.4c23.7,0,46.9,4.5,68.8,13.4 l-35.9,88.4c-10.5-4.3-21.6-6.4-33-6.4c-11.4,0-22.5,2.2-33,6.4C851.5,1027,841.7,1033.5,833.4,1041.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M633.3,458.5l-35.9-88.4c94.8-38.5,195.1-58,297.9-58c102.8,0,203,19.5,297.9,58l-35.9,88.4 c-83.4-33.8-171.6-51-262-51C804.8,407.5,716.7,424.7,633.3,458.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1042.8,740.6l35.9-88.4c60.5,24.5,114.7,60.5,161.2,107l-67.5,67.5C1134.9,789.2,1091.3,760.3,1042.8,740.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M443.6,1287.1c-23.7-58.4-35.7-120.1-35.7-183.3c0-63.3,12-125,35.7-183.3l88.4,35.8 c-19,47-28.7,96.6-28.7,147.5c0,50.9,9.7,100.5,28.7,147.5L443.6,1287.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M631.7,1210.8c-13.8-34.1-20.8-70.1-20.8-107c0-36.9,7-72.9,20.8-107c14.3-35.3,35.3-67,62.5-94.1l67.5,67.5v0 c-18.1,18.1-32,39.1-41.5,62.5c-9.2,22.6-13.8,46.6-13.8,71.1c0,24.6,4.7,48.5,13.8,71.2l0,0L631.7,1210.8z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoInteleca);
export default __webpack_public_path__ + "static/media/logo_inteleca.74907403cd8a4acdfd8c5313b0b280c3.svg";
export { ForwardRef as ReactComponent };